export const RoundsReport = {
  report: "Report",
  reports: "Reports",
  createReport: "Create report",
  deleteReport: "Delete report",
  noReportsHaveBeenCreated:
    "No reports have been created. Please create a report before proceeding.",
  pdfPreview: "PDF preview",
  pleaseAddAssets: "Please add one or more assets to view their rounds.",
  totalRounds: "Total rounds",
  noRoundsAvailable: "No rounds available.",
  pleaseSelectAReport: "Please select a round report or create a new one.",
  reportName: "Report name",
  enterReportName: "Enter report name",
  reportDescription: "Report description",
  enterReportDescription: "Enter report description",
  round: "Round",
  rounds: "Rounds",
  generalConfig: "General configuration",
  emailAddresses: "Email Addresses",
  areYouSureYouWantToDelete:
    "Are you sure you want to delete the round report ",
  onceDeleted: "Once deleted, it cannot be recovered.",
  emailSendingTime: "Email sending time",
  minuteSelectionMustBe: "The minute selection must be a multiple of 30.",
  maximumImagesPerRound: "Maximum images per round",
  maximumTimeBetweenEvents: "Maximum time between events (minutes)",
  roundStartTime: "Round start time",
  roundEndTime: "Round end time",
  linkedAssets: "Linked assets",
  unlinkedAssets: "Unlinked assets",
  linkedUsers: "Linked users",
  unlinkedUsers: "Unlinked users",
  emailInputError: "The input is not a valid email",
  sureToCancel: "Sure to cancel?",
  sureToDelete: "Sure to delete?",
  oneOrMoreEmailsInvalid: "One or more of the entered emails are invalid.",
  addOneOrMoreEmails: "Add one or more emails (separated by commas).",
  inTotal: "in total.",
};
